/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_OptionAwardListDto } from '../models/PagedResultDto_OptionAwardListDto';
import type { Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto } from '../models/Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobRequestDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobRequestDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionAwardVestingScheduleDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionAwardVestingScheduleDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_OptionDocumentDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_OptionDocumentDto';
import type { Wealthlane_AwardService_Dtos_OptionAwardApproval_OptionAwardApprovalDto } from '../models/Wealthlane_AwardService_Dtos_OptionAwardApproval_OptionAwardApprovalDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OptionAwardApprovalService {

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardApprovalApproveOptionAwards(
        requestBody?: Array<Wealthlane_AwardService_Dtos_OptionAwardApproval_OptionAwardApprovalDto>,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award-approval/approve-option-awards',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardApprovalRejectOptionAwards(
        requestBody?: Array<Wealthlane_AwardService_Dtos_OptionAwardApproval_OptionAwardApprovalDto>,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award-approval/reject-option-awards',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param approvalStatusIds
     * @param createdFromDate
     * @param createdToDate
     * @param grantFromDate
     * @param grantToDate
     * @param employeeStatuses
     * @param optionStatus
     * @param optionAcceptance
     * @param isEarlyExercisable
     * @param approvedFromDate
     * @param approvedToDate
     * @param publishFromDate
     * @param publishToDate
     * @param expirationFromDate
     * @param expirationToDate
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_OptionAwardListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardApprovalOptionAwardList(
        approvalStatusIds?: Array<number>,
        createdFromDate?: string,
        createdToDate?: string,
        grantFromDate?: string,
        grantToDate?: string,
        employeeStatuses?: Array<number>,
        optionStatus?: number,
        optionAcceptance?: number,
        isEarlyExercisable?: boolean,
        approvedFromDate?: string,
        approvedToDate?: string,
        publishFromDate?: string,
        publishToDate?: string,
        expirationFromDate?: string,
        expirationToDate?: string,
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_OptionAwardListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award-approval/option-award-list',
            query: {
                'ApprovalStatusIds': approvalStatusIds,
                'CreatedFromDate': createdFromDate,
                'CreatedToDate': createdToDate,
                'GrantFromDate': grantFromDate,
                'GrantToDate': grantToDate,
                'EmployeeStatuses': employeeStatuses,
                'OptionStatus': optionStatus,
                'OptionAcceptance': optionAcceptance,
                'IsEarlyExercisable': isEarlyExercisable,
                'ApprovedFromDate': approvedFromDate,
                'ApprovedToDate': approvedToDate,
                'PublishFromDate': publishFromDate,
                'PublishToDate': publishToDate,
                'ExpirationFromDate': expirationFromDate,
                'ExpirationToDate': expirationToDate,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param optionAwardId
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardApprovalOptionAwardOverview(
        optionAwardId: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award-approval/option-award-overview/{OptionAwardId}',
            path: {
                'OptionAwardId': optionAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param optionAwardId
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardVestingScheduleDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardApprovalOptionAwardVestingSchedule(
        optionAwardId: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardVestingScheduleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award-approval/option-award-vesting-schedule/{OptionAwardId}',
            path: {
                'OptionAwardId': optionAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param optionAwardId
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionDocumentDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardApprovalOptionAwardDocuments(
        optionAwardId: string,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_OptionAward_OptionDocumentDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award-approval/option-award-documents/{OptionAwardId}',
            path: {
                'OptionAwardId': optionAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardApprovalDownloadDocument(
        requestBody?: Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobRequestDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBlobDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award-approval/download-document',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardApprovalApproveBulkOption(
        requestBody?: Array<Wealthlane_AwardService_Dtos_OptionAwardApproval_OptionAwardApprovalDto>,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award-approval/approve-bulk-option',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionAwardApprovalRejectBulkOption(
        requestBody?: Array<Wealthlane_AwardService_Dtos_OptionAwardApproval_OptionAwardApprovalDto>,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_BulkImport_BulkImportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-award-approval/reject-bulk-option',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
